// extracted by mini-css-extract-plugin
export default {"titleMobile":"CaavL","dateLocationMobile":"_95Czv"};